import { render, staticRenderFns } from "./CouponCollectQuota.vue?vue&type=template&id=56dce282&"
import script from "./CouponCollectQuota.vue?vue&type=script&lang=js&"
export * from "./CouponCollectQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports